const CATEGORIES = [
    { value: "gym", label: "Academia" },
    { value: "nutrition", label: "Nutrição" },
    { value: "yoga", label: "Yoga" },
    { value: "pilates", label: "Pilates" },
    { value: "crossfit", label: "CrossFit" },
    { value: "running", label: "Corrida" },
    { value: "cycling", label: "Ciclismo" },
    { value: "mindset", label: "Mentalidade" },
    { value: "psicology", label: "Psicologia" },
    { value: "suplements", label: "Suplementos" },
    { value: "home_workout", label: "Treino em Casa" },
    { value: "swimming", label: "Natação" },
    { value: "climbing", label: "Escalada" },
    { value: "soccer", label: "Futebol" },
    { value: "basketball", label: "Basquete" },
    { value: "tennis", label: "Tênis" },
    { value: "golf", label: "Golfe" },
    { value: "baseball", label: "Beisebol" },
    { value: "rugby", label: "Rugby" },
    { value: "hockey", label: "Hóquei" },
    { value: "volleyball", label: "Vôlei" },
    { value: "softball", label: "Softball" },
    { value: "gymnastics", label: "Ginástica" },
    { value: "cheerleading", label: "Cheerleading" },
    { value: "lacrosse", label: "Lacrosse" },
    { value: "triathlon", label: "Triatlo" }
];

export default CATEGORIES;
